import { Selector } from "@/ds/custom/Selector";
import { ChartHistoryDurationOptions } from "@/lib/domain/ChartHistoryDuration";
import { useUserPreferencesState } from "@/lib/state/UserPreferencesState";
import { TimerIcon } from "lucide-react";
import type { FC } from "react";

export const ChartHistoryDurationSelector: FC = () => {
	const { state, dispatchSetChartHistoryDuration } = useUserPreferencesState();

	return (
		<div className="p-3 border-b">
			<Selector
				className="w-full"
				value={state.chartHistoryDuration}
				onChange={dispatchSetChartHistoryDuration}
				placeholder="Time Range"
				icon={TimerIcon}
				options={ChartHistoryDurationOptions} />
		</div>
	);
};
